"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const colors_1 = require("@material-ui/core/colors");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const lodash_1 = require("lodash");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const config_1 = require("config");
const credit_portal_components_1 = require("credit-portal-components");
const inline_colors_1 = require("inline-colors");
const utils_1 = require("utils");
const forms_1 = require("../../forms");
const reducer_1 = require("../reducer");
function ApplicantShow({ followOnOperation, handleSubmit, handleSubmitFailure, handleSubmitSuccess, personalInfo, practice, applicationEnvironment, }) {
    const { search } = (0, react_router_dom_1.useLocation)();
    if ((0, lodash_1.isNil)(personalInfo)) {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: {
                pathname: config_1.APPLICANTS_URL,
                search: search,
            } }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "applicant-personal-info", children: (0, jsx_runtime_1.jsxs)("div", { className: "application-instructions", children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-header", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Find out now if you ", (0, jsx_runtime_1.jsx)("span", { children: "pre-qualify" }), " for our Access Loan product* without impacting your credit."] }), (0, jsx_runtime_1.jsx)("p", { children: "It's quick, easy, and secure with instant results." })] }), (0, jsx_runtime_1.jsxs)("ul", { className: "info-content", children: [practice && practice.name && practice.locationId && ((0, jsx_runtime_1.jsxs)("li", { className: "info", children: ["You've selected practice ", (0, jsx_runtime_1.jsx)("b", { children: practice.name }), "."] })), (0, jsx_runtime_1.jsxs)("li", { children: ["If your credit is locked or frozen, you'll need to remove the freeze before applying.", (0, jsx_runtime_1.jsx)("div", { className: "tooltip-container", children: (0, jsx_runtime_1.jsx)(core_1.Tooltip, { enterTouchDelay: 0, placement: "left", title: (0, jsx_runtime_1.jsx)("p", { style: {
                                                fontSize: '14px',
                                                color: inline_colors_1.INLINE_COLORS.whiteBase,
                                            }, children: "If you placed a freeze on your credit file, please contact each credit reporting agency directly to remove the credit freeze before going through the apply process." }), children: (0, jsx_runtime_1.jsx)(core_1.IconButton, { className: "icon-button", children: (0, jsx_runtime_1.jsx)(Info_1.default, { style: { color: colors_1.blue[800] } }) }) }) })] })] }), (0, jsx_runtime_1.jsx)(forms_1.PersonalInfoForm, { initialValues: formatInitialValues(personalInfo), followOnOperation: followOnOperation, practice: practice, onSubmit: handleSubmit, onSubmitSuccess: handleSubmitSuccess, onSubmitFail: handleSubmitFailure, fieldsToExclude: applicationEnvironment.fieldsToExclude }), (0, jsx_runtime_1.jsx)(credit_portal_components_1.ServiceProviderDisclosures, {})] }) }));
}
function mapStateToProps(state) {
    return {
        personalInfo: reducer_1.selectors.personalInfo(state),
    };
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(ApplicantShow);
function formatInitialValues(initialValues) {
    if ((0, lodash_1.isNil)(initialValues))
        return {};
    const compactedInitialValues = (0, lodash_1.omitBy)(initialValues, (value) => (0, lodash_1.isNil)(value));
    const { alternatePhone, dateOfBirth } = compactedInitialValues;
    const usDateOfBirth = (0, utils_1.formatISODateStringAsUSMonthDayYear)(dateOfBirth);
    const homeNumberCheck = !(0, lodash_1.isNil)(alternatePhone);
    return {
        ...compactedInitialValues,
        dateOfBirth: usDateOfBirth,
        homeNumberCheck,
    };
}
